<template>
  <ButtonIcon :id="container_id" :path="path">
    <EyeIcon class="h-5 w-5 text-black/50 inline-flex" />
  </ButtonIcon>
</template>

<script>
import ButtonIcon from "@/components/buttons/ButtonIcon.vue";
import { EyeIcon } from "@heroicons/vue/24/solid";
export default {
  components: {
    ButtonIcon,
    EyeIcon,
  },
  props: {
    container_id: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "/",
    },
  },
};
</script>
